import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class compraProveedorService {
    
    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-proveedor/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-proveedor/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-proveedor/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/
}

export default new compraProveedorService();